import { Container, Row, Col, Form } from "react-bootstrap";
import { Button } from "@mui/material";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import { Link } from "react-router-dom";
import BackButton from "../../Includes/BackButtonEntityAccount";
import entity_arrow from "../../../images/entity_arrow.png";
import reg_entity from "../../../images/create_entity_ques1_icon1.png";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setEmail,
  setwizardPageNumber,
  setEmailVerify,
  setUserID,
  setEntityAccountUserDetails,
  setwizardPageName,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError } from "MyComponents/Toaster";
import Spacer from "MyComponents/UI/Spacer";
import { updateEntityKycDraftStep } from "Utils/entityKycDraft";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

interface Props {}

const CreateEntityLastQues: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );

  const userID = useSelector((state: RootState) => state.entityAccount.userID);

  const confirmInfo = async () => {
    try {
      if (userID) {
        await updateEntityKycDraftStep(userID, 'EntityAccountUser', { verificationInfoConfirmed: true });
      }
      dispatch(setwizardPageName("businessInfo"));
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
      localStorage.setItem('pageName', "businessInfo");
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress.");
    }
  };

  return (
    <>
      <Container fluid className=" min-vh-custom">
        <Row className="px-3 px-md-5 mt-5">
          <Col md={12}>
            <div className="text-center ">
              <img src={reg_entity} width={50} />
              <h3 className="mt-3">{t('kyc.verify_business')}</h3>
              <p className="mt-3 text-secondary ">
                {t('kyc.verify_business_desc')}
              </p>
            </div>
            <Row className="justify-content-center">
              <Col md={4} className=" p-3 rounded-3">
                <h6>{t('kyc.what_youll_need')}</h6>

                <p className="text-secondary small d-flex align-items-center">
                  <CheckCircleIcon sx={{ color: "#00D084", fontSize: 20, mr: 1 }} /> {t('kyc.org_docs')}
                </p>
                <p className="text-secondary small d-flex align-items-center">
                  <CheckCircleIcon sx={{ color: "#00D084", fontSize: 20, mr: 1 }} /> {t('kyc.proof_business_address')}
                </p>
                <p className="text-secondary small d-flex align-items-center">
                  <CheckCircleIcon sx={{ color: "#00D084", fontSize: 20, mr: 1 }} /> {t('kyc.business_owner_info')}
                </p>
                <p className="text-secondary small d-flex align-items-center">
                  <CheckCircleIcon sx={{ color: "#00D084", fontSize: 20, mr: 1 }} /> {t('kyc.govt_issued_id')}
                </p>

                <div className="py-1">
                  <Button
                    onClick={confirmInfo}
                    variant="contained"
                    sx={{
                      backgroundColor: "#00D084",
                      borderRadius: "40px",
                      border: "none",
                      textTransform: "none",
                      width: { xs: "100%", md: "auto" },
                      minWidth: { md: "200px" },
                      py: 1.2,
                      "&:hover": {
                        backgroundColor: "#00B873",
                      },
                    }}
                  >
                    {t('kyc.confirm_info')}
                  </Button>

                  <p className="mt-4 mb-0 text-secondary small ">
                    <Link to={""} style={{ fontSize: "12px" }}>
                      {t('kyc.see_full_docs_list')} &nbsp;&nbsp;{" "}
                      <img src={entity_arrow} width={15}></img>
                    </Link>
                  </p>
                  <p className=" text-secondary small ">
                    <Link to={""} style={{ fontSize: "12px" }}>
                      {t('kyc.see_acceptable_docs')} &nbsp;&nbsp;{" "}
                      <img src={entity_arrow} width={15}></img>
                    </Link>
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {},
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "entityWizard",
  enableReinitialize: true,
})(CreateEntityLastQues);

export default connect(mapStateToProps)(form);
